export default {
  LOCALIZATION: 'localization',
  CURRENT_PLATFORM: 'current_platform',
  CURRENT_SELLER: 'current_seller',
  CURRENT_SITE: 'current_site',
  SIDER_COLLAPSED: 'sider_collapsed',
};
